import { MoreHorizontal, Trash } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useSaasEscrow } from 'src/context/saas-escrow';
import { InvitationStatusEnum } from 'src/graphql/schema';

const ActionDropdown = () => {
  const {
    saasEscrow: { policy, escrowInvitation },
    setIsTerminationDialogOpen,
  } = useSaasEscrow();

  if (escrowInvitation?.status === InvitationStatusEnum.Rejected || !policy.write) return null;

  const onRequestTermination = () => setIsTerminationDialogOpen(true);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="size-9 shrink-0">
          <MoreHorizontal />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end">
        <DropdownMenuGroup>
          <DropdownMenuItem
            className="text-destructive focus:text-destructive!"
            onClick={onRequestTermination}
            disabled={!policy.requestTermination}
          >
            <Trash />
            Request termination
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ActionDropdown;
